import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
InputAdornment  
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import _ from "lodash";
import { useFormik } from "formik";
import { useDropzone } from "react-dropzone";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import HotelApi from "Services/Hotel";

//Data
import countryCodeData from "./data/countryCode/index.json";
import { apiUrl } from "../../../../Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SubcmpnyUpdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);

// Max file size
const maxFileSize = 5242880;
const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};
// File length validator
const fileLengthValidator = (file) => {
  if (file.size > maxFileSize) {
    alert(`File size is larger than ${formatBytes(maxFileSize)}`);
    return {
      code: "file-too-large",
      message: `File size is larger than ${formatBytes(maxFileSize)}`,
    };
  }
  return null;
};

  // Dropzone props
  const { getRootProps, getInputProps, open, fileRejections } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: formatBytes(maxFileSize),
    maxFiles: 1,
    accept: "image/*",
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      let fileLength = acceptedFiles.map((file) => file.size);
      if (acceptedFiles && fileLength < maxFileSize) {
        const file = acceptedFiles[0];
      //console.log("typeof file-->", typeof(file));

        // Convert file to Base64
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result;
          formik.setFieldValue("passengerProfileImagefile", file);
          formik.setFieldValue("passengerProfileImage", base64String); // Keep the file for form submission
        };
        reader.onerror = (error) => {
          console.error("Error converting file to Base64:", error);
        };
        reader.readAsDataURL(file); // Convert file to Base64
      }
    },
  });

  // Fetch subcompany Details

  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        console.log('subcompany',res?.data?.data);
        setDetails(res?.data?.data);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    HotelApi.getHotelDetails(id).then(onSuccess, onFailure);
  }, [id]);

  useEffect(() => {
    openDialog && getDetails();
  }, [openDialog]);

  const handleUpdateHotel = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    let validatationPass = true;

    const data = {
      firstName: formValues?.firstName,
      user_name: formValues?.firstName,
      country: formValues?.country,
      countryCode: formValues?.countryCode,
      mobileNumber: formValues?.mobile,
      email: formValues?.email,
      password: formValues?.password,
      image: formValues?.passengerProfileImagefile,      
      hotelPercentage: formValues?.hotelPercentage,
      address : formValues?.address,
    };

    console.log('data--->',data);

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        dispatch(
          showSnackbar({
            message: "Hotel Details Updated Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        //console.log("the response data ", res?.data);
        // setProfileDetails([]);
        formik.resetForm();
        handleClose();
        // getProfileDetails();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while Update Hotel",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    if (validatationPass) {
      HotelApi.updateHotel(id, { ...data }).then(onSuccess, onFailure);
    }
  };

  // Formik - Set fetched values for master
  useEffect(() => {
    const updateFormValues = async () => {
    if (!_.isEmpty(details)) {
      formik.setFieldValue("firstName", details?.firstName);
      formik.setFieldValue("hotelPercentage", details?.hotelDetails?.hotelPercentage);
      formik.setFieldValue("countryCode", details?.countryCode);
      formik.setFieldValue("mobile", details?.mobileNumber);
      formik.setFieldValue("email", details?.email);
      formik.setFieldValue("passengerProfileImage", `${apiUrl}${details?.image_local}`);
      formik.setFieldValue("passengerProfileImagefile", `${apiUrl}${details?.image_local}`);
      formik.setFieldValue("address", details?.address);
      formik.setFieldValue("country", details?.country);
    }
  }
    updateFormValues();
  }, [details]);

  // Formik

  const formik = useFormik({
    initialValues: {
      firstName: "",
      email: "",
      password: "",
      passConfirmation: "",
      hotelPercentage: "",
      country: "",
      mobile: "",
      countryCode: "",
      address:"",
      passengerProfileImage:"",
      passengerProfileImagefile:""
    },
    validationSchema: yup.object({
      firstName: yup.string().required("Hotel Name is required").nullable(),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required")
        .nullable(),
      countryCode: yup.string().required("Country Code is required").nullable(),
      mobile: yup
        .string()
        .matches(/^\d{1,15}$/, "Invalid mobile number")
        .required("Mobile is required")
        .nullable(),
      hotelPercentage: yup
        .number()
        .typeError("Hotel percentage must be a number")
        .required("Hotel percentage is required")
        .min(0, "Hotel percentage cannot be less than 0")
        .max(100, "Hotel percentage cannot be more than 100")
        .nullable(),
            address: yup.string().required("address is required").nullable(),   
      country: yup.string().required("Country is required").nullable(),
password: yup
  .string()
  .nullable()
  .when([], {
    is: () => true, // always check, but conditionally require
    then: (schema) =>
      schema.min(6, "Password must be at least 6 characters"),
  }),

passConfirmation: yup
  .string()
  .nullable()
  .when("password", {
    is: (val) => val && val.length > 0, // only when password is entered
    then: (schema) =>
      schema
        .required("Confirm password is required")
        .oneOf([yup.ref("password"), null], "Passwords must match"),
    otherwise: (schema) => schema.notRequired(),
  }),      
    }),
    enableReinitialize: true,
    onSubmit: handleUpdateHotel,
  });

   const [showPassword, setShowPassword] = useState(false);
   const [showConfirmPassword, setShowConfirmPassword] = useState(false); 

  const handleToggleNewPasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };


  //Tabs

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Update Hotel/restaurant
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <section className={classes.avatarContainer}>
                <div className={classes.avatarWrapper}>
                  <div className={classes.avatar}>
                    <img
                      src={formik?.values?.passengerProfileImage ?
                        formik?.values?.passengerProfileImage:
                        "/assets/images/user/avatar.png"
                      }
                      alt="avatar"
                      className={classes.img}
                      style={{ objectFit: "cover" }}
                    />
                    <section
                      {...getRootProps()}
                      onClick={open}
                      className={classes.editIcon}
                    >
                      <input {...getInputProps()} />
                      <CameraAltOutlinedIcon />
                    </section>
                  </div>
                </div>
              </section>
            </Grid>
          </Grid>
          <Grid container>
            <section className={classes.container}>
              <Grid item xs={12} className={classes.detailsContainer}>
                <Grid container className={classes.containerWrapper}>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid container>
                      <Grid item xs={12} md={12} lg={12}>
                        <Grid container>
                        <Grid
                            item
                            md={12}
                            lg={12}
                            xl={12}
                            className={classes.textFieldWrapper}
                          >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          id="firstName"
                          label="Hotel Name"
                          value={formik?.values?.firstName}
                          defaultValue={formik?.values?.firstName}
                          onChange={formik.handleChange}
                          error={
                            formik?.errors?.firstName &&
                            formik?.touched?.firstName
                          }
                          helperText={
                            formik?.errors?.firstName &&
                            formik?.touched?.firstName &&
                            formik?.errors?.firstName
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                          </Grid>  

                       </Grid>
                      </Grid>
                      <Grid item md={12} lg={12} xl={12}>
                        <Grid container>
                          <Grid
                            item
                            md={4}
                            lg={4}
                            xl={4}
                            className={classes.textFieldWrapper}
                          >
                            <TextField
                              inputProps={{
                              form: {
                                    autocomplete: 'off',
                                  },
                              }}
                              name="countryCode"
                              id="countryCode"
                              label="Country Code"
                              value={formik?.values?.countryCode}
                              defaultValue={formik?.values?.countryCode}
                              onChange={formik?.handleChange}
                              select
                              error={
                                formik?.errors?.countryCode &&
                                formik?.touched?.countryCode
                              }
                              helperText={
                                formik?.errors?.countryCode &&
                                formik?.touched?.countryCode &&
                                formik?.errors?.countryCode
                              }
                              fullWidth
                              variant="outlined"
                              size="small"
                            >
                              {countryCodeData.map((country) => (
                                <MenuItem
                                  key={country.code}
                                  value={country.dial_code}
                                >
                                  {`${country.code} (${country.dial_code})`}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                          <Grid
                            item
                            md={8}
                            lg={8}
                            xl={8}
                            className={classes.textFieldWrapper}
                          >
                            <TextField
                              inputProps={{
                              form: {
                                    autocomplete: 'off',
                                  },
                              }}
                              name="mobile"
                              id="mobile"
                              label="Mobile Number"
                              value={formik?.values?.mobile}
                              defaultValue={formik?.values?.mobile}
                              onChange={formik?.handleChange}
                              error={
                                formik?.errors?.mobile &&
                                formik?.touched?.mobile
                              }
                              helperText={
                                formik?.errors?.mobile &&
                                formik?.touched?.mobile &&
                                formik?.errors?.mobile
                              }
                              fullWidth
                              variant="outlined"
                              size="small"
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="email"
                          id="email"
                          label="Email"
                          value={formik?.values?.email}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.email && formik?.touched?.email
                          }
                          helperText={
                            formik?.errors?.email &&
                            formik?.touched?.email &&
                            formik?.errors?.email
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="hotelPercentage"
                          id="hotelPercentage"
                          label="Hotel percentage"
                          value={formik?.values?.hotelPercentage || ""}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.hotelPercentage && formik?.touched?.hotelPercentage
                          }
                          helperText={
                            formik?.errors?.hotelPercentage &&
                            formik?.touched?.hotelPercentage &&
                            formik?.errors?.hotelPercentage
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        >
                        </TextField>
                      </Grid>                
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                  <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="password"
                          id="password"
                          autoComplete="new-password"
                          value={formik?.values?.password}
                          onChange={formik?.handleChange}
                          type={showPassword ? "text" : "password"} // Toggle password visibility
                          fullWidth
                          variant="outlined"
                          size="small"
                          label="Password*"
                          error={formik?.errors?.password && formik?.touched?.password}
                          helperText={
                            formik?.errors?.password &&
                            formik?.touched?.password &&
                            formik?.errors?.password
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle new password visibility"
                                  onClick={handleToggleNewPasswordVisibility}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="passConfirmation"
                          id="passConfirmation"
                          autoComplete="confirm-password"
                          value={formik?.values?.passConfirmation}
                          onChange={(e) => {
                            formik.handleChange(e);
                            formik.validateField("passConfirmation"); // Validate dynamically on each keystroke
                          }}
                          type={showConfirmPassword ? "text" : "password"} // Toggle password visibility
                          fullWidth
                          variant="outlined"
                          size="small"
                          label="Confirm Password*"
                          error={
                            formik?.errors?.passConfirmation && formik?.touched?.passConfirmation
                          }
                          helperText={
                            formik?.errors?.passConfirmation &&
                            formik?.touched?.passConfirmation &&
                            formik?.errors?.passConfirmation
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle confirm password visibility"
                                  onClick={handleToggleConfirmPasswordVisibility}
                                  edge="end"
                                >
                                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="country"
                          id="country"
                          select
                          label="Country"
                          value={formik?.values?.country || ""}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.country && formik?.touched?.country
                          }
                          helperText={
                            formik?.errors?.country &&
                            formik?.touched?.country &&
                            formik?.errors?.country
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        >
                          {countryCodeData.map((country) => (
                                <MenuItem
                                  key={country.code}
                                  value={country.name}
                                >
                                  {`${country.code} (${country.name})`}
                                </MenuItem>
                              ))}
                        </TextField>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          name="address"
                          id="address"
                          label="Address"
                          value={formik?.values?.address || ""}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.address && formik?.touched?.address
                          }
                          helperText={
                            formik?.errors?.address &&
                            formik?.touched?.address &&
                            formik?.errors?.address
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        >
                        </TextField>
                      </Grid> 

                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.sbtBtnWrapper}
                  >
                    <Button variant="contained" onClick={formik?.handleSubmit}>
                    Update Hotel/restaurant
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </section>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SubcmpnyUpdate;
